import axios from 'axios'

export function apiUpload(data) {
  return axios({
    url: 'https://codimdhk.floatai.cn/uploadimage',
    method: 'post',
    data
  })
}
